import { createSlice } from "@reduxjs/toolkit";

export const guarantorLogSlice = createSlice({
  name: "guarantorLog",
  initialState: {
    loading: false,
    guarantorLogList: [],
    guarantorLogCount: 0,
    guarantorLogParams: {
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
    },
    apiError: {},
  },
  reducers: {
    clearGuarantorLogData: (state) => {
      return {
        ...state,
        loading: false,
        guarantorLogList: [],
        guarantorLogCount: 0,
        guarantorLogParams: {
          no_of_pages: 0,
          page_size: 10,
          page: 1,
          search: "",
        },
      };
    },
    getGuarantorLog: (state) => {
      return {
        ...state,
        loading: true,
        guarantorLogList: [],
      };
    },
    guarantorLogSuccessful: (state, action) => {
      var response = action.payload;
      var noofpages = Math.ceil(
        response.count / state.guarantorLogParams?.page_size
      );
      return {
        ...state,
        guarantorLogList: response.results,
        guarantorLogCount: response.count,
        loading: false,
        guarantorLogParams: {
          ...state.guarantorLogParams,
          no_of_pages: noofpages,
        },
      };
    },
    SetGuarantorLogParams: (state, action) => {
      return {
        ...state,
        guarantorLogParams: action.payload,
      };
    },
    apiError: (state, action) => {
      return { ...state, loading: false, error_msg: action.payload };
    },
  },
});

export const {
  getGuarantorLog,
  guarantorLogSuccessful,
  SetGuarantorLogParams,
  clearGuarantorLogData,
  apiError,
} = guarantorLogSlice.actions;

export default guarantorLogSlice.reducer;
